import { render, staticRenderFns } from "./CardHegu3.vue?vue&type=template&id=6a1b0fa0&scoped=true&"
import script from "./CardHegu3.vue?vue&type=script&lang=js&"
export * from "./CardHegu3.vue?vue&type=script&lang=js&"
import style0 from "./CardHegu3.vue?vue&type=style&index=0&id=6a1b0fa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b0fa0",
  null
  
)

export default component.exports